import React from "react";
import { Link } from "react-router-dom";
import { TopMenu } from "../Pages/Home/TopMenu";
import { LanguageProvider, useLanguage } from "../Pages/Home/LanguageContext";
import "./PublicPageLayout.css";

export const PublicFooter: React.FC = () => (
  <footer className="v2-footer">
    <div className="v2-footer-inner">
      <span className="v2-footer-brand">LinguaTalk</span>
      <nav className="v2-footer-nav">
        <Link to="/placement-test?l=en-us">Placement Test</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/safety">Safety</Link>
        <Link to="/safety#delete-account">Delete Account</Link>
      </nav>
      <span className="v2-footer-copy">© {new Date().getFullYear()} LinguaTalk</span>
    </div>
  </footer>
);

interface PublicPageLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

export const PublicPageLayoutInner: React.FC<PublicPageLayoutProps> = ({
  children,
  showFooter = true,
}) => {
  const { language } = useLanguage();
  const isRtl = language === "fa" || language === "ar";

  return (
    <div className="v2-page public-page" dir={isRtl ? "rtl" : "ltr"}>
      <div className="v2-bg" aria-hidden="true">
        <div className="v2-blob v2-blob-1" />
        <div className="v2-blob v2-blob-2" />
        <div className="v2-blob v2-blob-3" />
        <div className="v2-grid" />
      </div>
      <div className="v2-content">
        <TopMenu />
        {children}
        {showFooter && <PublicFooter />}
      </div>
    </div>
  );
};

export const PublicPageLayout: React.FC<PublicPageLayoutProps> = (props) => (
  <LanguageProvider>
    <PublicPageLayoutInner {...props} />
  </LanguageProvider>
);
